const mapping: Record<string, string> = {
  id: 'dc=>dc.Id',
  name: 'dc=>dc.Name',
  parentId: 'dc=>dc.ParentId',
}

export const mapSortDeviceCategoryParam = (key: string) => mapping[key]
